module.exports = __webpack_public_path__ + "img/kids-jumping.b1e470b0.png";